module.exports = __webpack_public_path__ + "img/register-gift.438f5483.svg";